import { useId } from "react";
import {
  GardenGround,
  GROUND_Y,
  SkySvgShell,
  STARS,
  VIEW_WIDTH,
} from "@/app/components/weather/backgrounds/shared";

/**
 * CloudyNightSky — overcast night sky with moon glow diffusing behind cloud layers.
 * Full-viewport illustration; garden silhouettes anchor to the bottom edge.
 */
export function CloudyNightSky() {
  const uid = useId().replace(/:/g, "");
  const csky = `${uid}-csky`;
  const moonbleed = `${uid}-moonbleed`;
  const mooncore = `${uid}-mooncore`;
  const haze = `${uid}-haze`;
  const rimtop = `${uid}-rimtop`;

  return (
    <SkySvgShell>
      <defs>
        <linearGradient id={csky} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#050914" />
          <stop offset="35%" stopColor="#0A1428" />
          <stop offset="70%" stopColor="#111D3A" />
          <stop offset="100%" stopColor="#182448" />
        </linearGradient>

        <radialGradient id={moonbleed} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#D8CEFF" stopOpacity="0.28" />
          <stop offset="40%" stopColor="#B8AAEE" stopOpacity="0.1" />
          <stop offset="75%" stopColor="#9088CC" stopOpacity="0.03" />
          <stop offset="100%" stopColor="#7060AA" stopOpacity="0" />
        </radialGradient>

        <radialGradient id={mooncore} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#EEE8FF" stopOpacity="0.55" />
          <stop offset="50%" stopColor="#C8BEFF" stopOpacity="0.18" />
          <stop offset="100%" stopColor="#A898EE" stopOpacity="0" />
        </radialGradient>

        <linearGradient id={haze} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#111D3A" stopOpacity="0" />
          <stop offset="100%" stopColor="#0A1220" stopOpacity="0.95" />
        </linearGradient>

        <linearGradient id={rimtop} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#D0C8FF" stopOpacity="0.32" />
          <stop offset="100%" stopColor="#D0C8FF" stopOpacity="0" />
        </linearGradient>
      </defs>

      <rect width={VIEW_WIDTH} height={GROUND_Y + 33} fill={`url(#${csky})`} />

      {STARS.map(([x, y, r, o], i) => (
        <circle key={i} cx={x} cy={y} r={r} fill="#D8D4F8" opacity={o} />
      ))}

      <ellipse cx="290" cy="78" rx="130" ry="110" fill={`url(#${moonbleed})`} />
      <ellipse cx="290" cy="78" rx="62" ry="56" fill={`url(#${mooncore})`} />

      <g fill="#1A2B58" opacity="0.55">
        <ellipse cx="62" cy="55" rx="72" ry="26" />
        <ellipse cx="28" cy="50" rx="38" ry="20" />
        <ellipse cx="108" cy="50" rx="44" ry="21" />
        <ellipse cx="178" cy="62" rx="58" ry="22" />
        <ellipse cx="148" cy="56" rx="36" ry="18" />
        <ellipse cx="218" cy="57" rx="32" ry="17" />
        <ellipse cx="338" cy="58" rx="64" ry="24" />
        <ellipse cx="304" cy="52" rx="38" ry="19" />
        <ellipse cx="372" cy="53" rx="36" ry="18" />
      </g>

      <g fill="#1E2F5E" opacity="0.68">
        <ellipse cx="80" cy="88" rx="80" ry="30" />
        <ellipse cx="36" cy="82" rx="44" ry="22" />
        <ellipse cx="132" cy="82" rx="52" ry="24" />
        <ellipse cx="220" cy="96" rx="68" ry="27" />
        <ellipse cx="178" cy="88" rx="42" ry="22" />
        <ellipse cx="268" cy="90" rx="40" ry="21" />
        <ellipse cx="340" cy="90" rx="72" ry="28" />
        <ellipse cx="298" cy="83" rx="46" ry="22" />
        <ellipse cx="382" cy="84" rx="38" ry="20" />
      </g>

      <g fill="#243568" opacity="0.8">
        <ellipse cx="100" cy="122" rx="96" ry="36" />
        <ellipse cx="44" cy="114" rx="54" ry="28" />
        <ellipse cx="162" cy="114" rx="60" ry="28" />
        <ellipse cx="264" cy="118" rx="90" ry="34" />
        <ellipse cx="214" cy="110" rx="52" ry="26" />
        <ellipse cx="320" cy="110" rx="56" ry="26" />
        <ellipse cx="370" cy="128" rx="52" ry="30" />
        <ellipse cx="356" cy="118" rx="36" ry="22" />
        <ellipse cx="388" cy="120" rx="28" ry="18" />
      </g>

      <g opacity="0.72">
        <ellipse cx="92" cy="100" rx="82" ry="8" fill={`url(#${rimtop})`} />
        <ellipse cx="258" cy="97" rx="76" ry="9" fill={`url(#${rimtop})`} />
        <ellipse cx="368" cy="109" rx="46" ry="6" fill={`url(#${rimtop})`} />
      </g>

      <rect x="0" y="200" width={VIEW_WIDTH} height={GROUND_Y - 200} fill={`url(#${haze})`} />

      <GardenGround />
    </SkySvgShell>
  );
}
